import { FormProps } from '@backstage/plugin-scaffolder-react';

import {
  CatalogUniquenessErrorListTemplate,
  CatalogUniquenessFieldErrorTemplate,
} from './templates/catalogUniquenessErrorTemplates';

/**
 * Runtime Form props beyond the public FormProps pick. The scaffolder Stepper
 * spreads leftover keys onto RJSF Form, which replaces ErrorListTemplate.
 */
export const scaffolderFormProps = {
  templates: {
    ErrorListTemplate: CatalogUniquenessErrorListTemplate,
    FieldErrorTemplate: CatalogUniquenessFieldErrorTemplate,
  },
} as FormProps;
